import React, { useEffect, useRef, useState } from 'react'
import Popup from '../Popup/Popup'
import { ActionDropdownProps } from './ActionDropdown.types'
import Button from '../Button/Button'
import Icon from '../Icon/Icon'
const ActionDropdown: React.FC<ActionDropdownProps> = ({
    size = 'sm',
    type,
    isDiscreet = false,
    isDisabled = false,
    isMinimal = false,
    text,
    disabledTooltip,
    options = [],
}) => {
    const [showOptions, setShowOptions] = useState(false)
    const anchor = useRef(null)

    const renderOptions = () => {
        return options.map((o, i) => {
            return (
                <div
                    key={i}
                    className={`r-actiondropdown-item ${o.isDisabled ? 'r-state-disabled' : ''}`}
                    onClick={() => {
                        if (o.isDisabled) {
                            return
                        }
                        handleClose()
                        setTimeout(() => {
                            if (o.onClick) {
                                o.onClick()
                            }
                        })
                    }}
                >
                    {o.text}
                    {o.isDisabled && o.disabledMessage ? (
                        <div className={'r-disabled-message'}>{o.disabledMessage}</div>
                    ) : null}
                </div>
            )
        })
    }

    const handleClose = () => {
        setShowOptions(false)
    }

    useEffect(() => {
        if (showOptions) {
            document.addEventListener('click', handleClose)
        } else {
            document.removeEventListener('click', handleClose)
        }
    }, [showOptions])

    return (
        <div className={'r-actiondropdown-container'}>
            <Button
                isDisabled={isDisabled}
                disabledTooltip={disabledTooltip}
                isDiscreet={isDiscreet}
                isMinimal={isMinimal}
                type={type}
                size={size}
                onClick={(e) => {
                    e.stopPropagation()
                    setShowOptions(true)
                }}
                ref={anchor}
                label={
                    <span>
                        {text}{' '}
                        <span style={{ marginLeft: '5px' }}>
                            <Icon size={'sm'} type={'chevron-down'} />
                        </span>
                    </span>
                }
            />
            <Popup anchor={anchor} show={showOptions} pos={'bottom'} align={'left'}>
                <div className={'r-actiondropdown-options-container'}>{renderOptions()}</div>
            </Popup>
        </div>
    )
}

export default ActionDropdown
